export const homeObjOne = {
  lightBg: true,
  lightText: false,
  bglight:false,
  lightTopLine: true,
  lightTextDesc: false,
  topLine: 'Product Highlights:',
  headline: 'We provide Elevators for all buildings.',
  description:
    'Machine room and machine roomless designs.         We offer high speed solutions.-Industry leading after sales service, maintenance plans are applied according the type of your building.-We utilize dual core, high performance, micro controllers to ensure maximum safety and performance. Destination control systems are also an option with our elevators.                      Our elevator consume less electricity,  our innovative machines and drive controller, Moreover, use of L.E.D lighting across all of our cabins further saves your electricity bills..',
  buttonLabel: 'Learn more',
  imgStart: '',
  img: require('../../images/img1.png'),
  alt: ''
};

export const homeObjTwo = {
  lightBg: true,
    bglight:false,
  lightText: true,
  lightTopLine: true,
  lightTextDesc: true,
  topLine: 'Product Highlights:',
  headline: 'Escalators & Moving walks for commercial, administrative, and heavy traffic buildings',
  description:
    '- We provide indoor & outdoor Escalators and Moving Walks. -Safe and Reliable Solutions. -Industry leading after sales service, maintenance plans are applied according the type of your building. -Also, we provide inclined & horizontal products.',
  buttonLabel: 'Learn more',
  imgStart: 'start',
  img: require('../../images/img4.png'),
  alt: 'Vault'
};

export const homeObjThree = {
  lightBg: true,
  lightText: false,
    bglight:true,

  lightTextDesc: false,
  topLine: '',
  headline: 'Our maintenance plan ensures maximum service life plus maximum comfort for our customers.',
  description:
    "We provide product modernization service, as supply & installation all spare parts of your product to keep it more comfortable and increase its efficiency.."
    ,
  buttonLabel: 'Learn more',
  imgStart: '',
  img: require('../../images/img3.png'),
  alt: 'Vault'
};

